import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getSellerOrder, getSellerOrders, updateSellerOrderStatus } from '../api';

export const sellerOrdersKey = (sellerId) => ['seller-orders', sellerId];

export function useSellerOrders(sellerId) {
  return useQuery({
    queryKey: sellerOrdersKey(sellerId),
    queryFn: async () => (await getSellerOrders(sellerId)).data,
    enabled: Boolean(sellerId),
  });
}

export function useSellerOrder(sellerId, orderId, fallbackOrder) {
  return useQuery({
    queryKey: [...sellerOrdersKey(sellerId), orderId],
    queryFn: async () => (await getSellerOrder(orderId)).data,
    enabled: Boolean(sellerId && orderId),
    initialData: fallbackOrder,
  });
}

export function useSellerOrderAction(sellerId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ orderId, status }) => updateSellerOrderStatus(orderId, status),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: sellerOrdersKey(sellerId) }),
  });
}
